import React, { BaseSyntheticEvent } from 'react';

export const getHandlerKayPress = (key: string, cb: (e: React.KeyboardEvent) => void) => {
  return (e: React.KeyboardEvent) => {
    if (e.key === key) {
      cb(e);
    }
  };
};

export const handlerStop = (e: BaseSyntheticEvent) => {
  e.stopPropagation();
};

export const handlerStopAndPrevent = (e: BaseSyntheticEvent) => {
  e.stopPropagation();
  e.preventDefault();
};

type DialogCloseReason = 'backdropClick' | 'escapeKeyDown';

/**
 * MUI 9 removed Dialog's `disableEscapeKeyDown`; a dialog that must stay open
 * on Escape filters the close reason instead (the documented replacement).
 * `onClose={ignoreEscapeKeyDown(onClose)}` keeps the backdrop click working.
 */
export const ignoreEscapeKeyDown = <E>(onClose?: (event: E, reason: DialogCloseReason) => void) => {
  return (event: E, reason: DialogCloseReason) => {
    if (reason !== 'escapeKeyDown') {
      onClose?.(event, reason);
    }
  };
};
